module.exports = "<svg viewBox=\"0 0 80 80\"><path d=\"M80 0H0v80h80V0z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/square.svg
// module id = 307
// module chunks = 1